const Main = ({ id, classes, children }) => {

    return (

        <main id={id} className={classes}>
            {children}
        </main>
    )
}

export default Main
